// extracted by mini-css-extract-plugin
export var mainImageContainer = "MainImage-module--mainImageContainer--iL20x";
export var svgImage = "MainImage-module--svgImage--SR8bm";